/**
 * Parent Landing Page - Family-focused Marketing Page
 * Epic 18: High-Performance Marketing Site with Static Generation at Edge
 */

import React from 'react';
import HighPerformanceLandingPage from './HighPerformanceLandingPage';

const ParentLanding: React.FC = () => {
  return <HighPerformanceLandingPage variant="parent" />;
};

export default ParentLanding;

// Static paths for parent-specific content
export async function getStaticPaths() {
  return {
    paths: [{ params: { locale: 'en' } }, { params: { locale: 'es' } }, { params: { locale: 'fr' } }],
    fallback: true,
  };
}
